// extracted by mini-css-extract-plugin
module.exports = {"tagTitle":"index_tagTitle__QePkI","text":"index_text__x5Jmo"};